module.exports = __webpack_public_path__ + "static/markdown/vue-vuex.md";